export default ({ response }) => {
	return response.json();
};
